export default __webpack_public_path__ + "static/media/newVpayMobile.a3b6bb12.png";